import { type IncidentListItem, NOT_CRAWLER_SCOPED } from '@prerender/diagnostics-api';

import { crawlerCategoryHeadlineSubject } from './crawlerCategoryLabels';
import { metricSentence } from './metricSentence';

export type IncidentHeadlineInput = Pick<
  IncidentListItem,
  'crawlerCategory' | 'headlineDomainCount' | 'headlineDomain' | 'metricLabel' | 'metricValue'
>;

export function incidentHeadline({
  crawlerCategory,
  headlineDomainCount,
  headlineDomain,
  metricLabel,
  metricValue,
}: IncidentHeadlineInput): string {
  if (crawlerCategory === NOT_CRAWLER_SCOPED) return metricSentence(metricLabel, metricValue);

  const where = headlineDomainCount === 1 ? headlineDomain : `${headlineDomainCount} domains`;

  return `${crawlerCategoryHeadlineSubject(crawlerCategory)} traffic dropped below its usual baseline on ${where}`;
}
